import moment from 'moment';
export const snakeToCamel = str => {
  return str.toLowerCase().replace(/([-_]\w)/g, g => g[1].toUpperCase());
};

export const toPascalCase = str => {
  let camelCase = snakeToCamel(str);
  let pascalCase = camelCase[0].toUpperCase() + camelCase.substr(1);
  return pascalCase;
};

export const toUnderscoreUpperCase = str => {
  return toUnderscoreCase(str).toUpperCase();
};

export const toUnderscoreCapslock = str => {
  return str.replace(/[^A-Z0-9]+/gi, '_').toUpperCase();
};

export const toUnderscoreCase = str => {
  return str
    .replace(/\.?([A-Z]+)/g, (x, y) => {
      return '_' + y.toLowerCase();
    })
    .replace(/^_/, '');
};

export const toLabelFormat = str => {
  const wordRegex = /[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g;
  const result = str.match(wordRegex);
  return result.join(' ');
};

export const hexToRGB = (hex, alpha) => {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
};

export const hexToRGBObj = (hex, alpha) => {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16),
    a = parseInt(alpha);

  if (alpha) {
    return {
      r: r.toString(),
      g: g.toString(),
      b: b.toString(),
      a: a.toString()
    };
  } else {
    return {
      r,
      g,
      b,
      a: '1'
    };
  }
};

export const rgbaToHex = rgba => {
  try {
    let r = parseInt(rgba.r);
    let g = parseInt(rgba.g);
    let b = parseInt(rgba.b);
    let a = parseFloat(rgba.a).toFixed(2);
    var outParts = [
      r.toString(16),
      g.toString(16),
      b.toString(16),
      Math.round(a * 255)
        .toString(16)
        .substring(0, 2)
    ];

    // Pad single-digit output values
    outParts.forEach(function (part, i) {
      if (part.length === 1) {
        outParts[i] = '0' + part;
      }
    });

    return '#' + outParts.join('');
  } catch (e) {
    return '#108495'; // default cosmos color
  }
};

export const toDecimal = (price, decimalPlaces) => {
  const priceString = price.toString();
  const pointIndex = priceString.indexOf('.');
  // Return the integer part if decimalPlaces is 0
  if (decimalPlaces === 0) {
    return priceString.substr(0, pointIndex);
  }

  // Return value with 0s appended after decimal if the price is an integer
  if (pointIndex === -1) {
    const padZeroString = '0'.repeat(decimalPlaces);

    return `${priceString}.${padZeroString}`;
  }

  // If numbers after decimal are less than decimalPlaces, append with 0s
  const padZeroLen = priceString.length - pointIndex - 1;
  if (padZeroLen > 0 && padZeroLen < decimalPlaces) {
    const padZeroString = '0'.repeat(padZeroLen);

    return `${priceString}${padZeroString}`;
  }

  return priceString.substr(0, pointIndex + decimalPlaces + 1);
};
export const toDecimalWithComma = (price, decimalPlaces) => {
  try {
    const priceString = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const pointIndex = priceString.indexOf('.');
    // Return the integer part if decimalPlaces is 0
    if (decimalPlaces === 0) {
      return priceString.substr(0, pointIndex);
    }

    // Return if price is NaN
    if (isNaN(price)) {
      return '0.00';
    }

    // Return value with 0s appended after decimal if the price is an integer
    if (pointIndex === -1) {
      const padZeroString = '0'.repeat(decimalPlaces);

      return `${priceString}.${padZeroString}`;
    }

    // If numbers after decimal are less than decimalPlaces, append with 0s
    const padZeroLen = priceString.length - pointIndex - 1;
    if (padZeroLen > 0 && padZeroLen < decimalPlaces) {
      const padZeroString = '0'.repeat(padZeroLen);

      return `${priceString}${padZeroString}`;
    }

    return priceString.substr(0, pointIndex + decimalPlaces + 1);
  } catch (err) {
    return '0.00';
  }
};

export const toDecimalWithCommaNew = (price, decimalPlaces) => {
  let priceString = price.toString();
  if (priceString.indexOf('.') >= 0) {
    const lastPart = priceString.substr(priceString.indexOf('.'));
    const firstPart = priceString.substr(0, priceString.indexOf('.'));
    priceString = firstPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    priceString = `${priceString}${lastPart}`;
  } else {
    priceString = priceString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const pointIndex = priceString.indexOf('.');
  // Return the integer part if decimalPlaces is 0
  if (decimalPlaces === 0) {
    return priceString.substr(0, pointIndex);
  }

  // Return value with 0s appended after decimal if the price is an integer
  if (pointIndex === -1) {
    const padZeroString = '0'.repeat(decimalPlaces);

    return `${priceString}.${padZeroString}`;
  }

  // If numbers after decimal are less than decimalPlaces, append with 0s
  const padZeroLen = priceString.length - pointIndex - 1;
  if (padZeroLen > 0 && padZeroLen < decimalPlaces) {
    const padZeroString = '0'.repeat(padZeroLen);

    return `${priceString}${padZeroString}`;
  }

  return priceString.substr(0, pointIndex + decimalPlaces + 1);
};

export const toNumberFormat = price => {
  try {
    const priceString = price.toString().replace(',', '');
    return Number(priceString);
  } catch (err) {
    return Number('0.00');
  }
};

export const toCodeDashFormat = str => {
  let cleanString = str.replace(/[^a-zA-Z ]/g, ' ');
  return cleanString.trim().replace(/\s+/g, '-').toLowerCase();
};
export const toCodeUpperCaseFormat = str => {
  let format = str.replace(/[^A-Z0-9]+/gi, '_').toUpperCase();
  return format.replace(/\s+/g, '');
};
export const filterFileRecon = (pchannel, date) => {
  try {
    switch (pchannel) {
      case 'gc':
        return moment(date).format('DD-MMM-YYYY');
      case '711_ph':
        return moment(date).format('MMDDYYYY');
      default:
        return moment(date).format('DD-MMM-YYYY');
    }
  } catch (e) {
    return moment().format('DD-MMM-YYYY');
  }
};
export const isoDateFormatter = (format, date) => {
  let dateFormat = new Date(date).toLocaleDateString('en-GB', {
    // you can use undefined as first argument
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  let dateValue = dateFormat.split(', ')[0];
  let timeValue = dateFormat.split(', ')[1];
  let year = dateValue.split('/')[2];
  let month = dateValue.split('/')[1];
  let day = dateValue.split('/')[0];
  let hour = timeValue.split(':')[0];
  let minute = timeValue.split(':')[1];
  let second = timeValue.split(':')[2];
  if (format === 'date_only') {
    return `${year}-${month}-${day}`;
  } else if (format === 'date_time') {
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  } else if (format === 'year') {
    return `${year}`;
  } else {
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
};

export const toDateFormatRequest = date => {
  return `${date} Asia/Manila`;
};

export const mongoDateStringFormatter = date => {
  try {
    let parseDate = JSON.parse(date);
    if (parseDate) {
      let getDate = parseDate['$date'];
      return getDate;
    } else {
      return date.replace(' Asia/Manila', '');
    }
  } catch (err) {
    return date.replace(' Asia/Manila', '');
  }
};

export const buildAcronym = str => {
  try {
    let acronym = str
      .match(/\b(\w)/g)
      .join('')
      .toUpperCase();
    if (acronym) {
      return acronym;
    } else {
      return '';
    }
  } catch (e) {
    return '';
  }
};
export const htmlToString = str => {
  try {
    let data = str.replace(/(<([^>]+)>)/gi, '');
    return data;
  } catch (e) {
    return str;
  }
};
export const toPascalLabel = str => {
  return str.replace(/[-_]/g, ' ').replace(/(\w)(\w*)/g, (match, firstChar, restOfString) => {
    return firstChar.toUpperCase() + restOfString.toLowerCase();
  });
};

export const capitalizeInitials = str => {
  try {
    const words = str.split(' ');

    const capitalizedWords = words.map(word => {
      if (word.length > 0) {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      }
      return '';
    });

    return capitalizedWords.join(' ');
  } catch (error) {
    return '';
  }
};

export const toTitleCase = str => {
  try {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  } catch (error) {
    return str;
  }
};

export const snakeToTitleCase = str => {
  try {
    return str
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  } catch {
    return str;
  }
};

export const formatReadableDate = dateStr => {
  try {
    const date = new Date(dateStr.replace(' ', 'T'));

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };

    return date.toLocaleString('en-US', options);
  } catch (error) {
    return '';
  }
};

export const formatFrequencyDisplay = freq => {
  try {
    switch (freq.toUpperCase()) {
      case 'DAYS':
        return 'day/s';
      case 'MINUTES':
        return 'minute/s';
      case 'HOURS':
        return 'hour/s';
      case 'MONTHS':
        return 'months/s';
      default:
        return freq;
    }
  } catch (e) {
    return freq;
  }
};

export const getFileType = file => {
  try {
    if (!file) return null;

    // get file_name extension
    const extension = (file?.file_name || file?.file?.original_name)
      ?.split('.')
      .pop()
      .toLowerCase();

    if (['pdf'].includes(extension)) return 'pdf';
    if (['png', 'jpg', 'jpeg', 'gif'].includes(extension)) return 'image';

    // Fallback to MIME if available
    if (file.mime_type?.startsWith('image')) return 'image';
    if (file.mime_type === 'application/pdf') return 'pdf';

    return 'other';
  } catch (error) {
    return null;
  }
};

/** Screaming Snake Case === "THIS_IS_EXAMPLE" */
export const screamingSnakeCaseToTitleCase = (string, defaultString = '') => {
  if (typeof string !== 'string' || !string.trim()) {
    return defaultString;
  }

  return string
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
};